export default __webpack_public_path__ + "static/Dashboard2-c1f2d2840d0ae1d5c2a14f95e3e4cb63.png";